<template>
  <div class="animated fadeIn master-kas-kecil-page">
    <b-row class="master-kas-kecil-row">
      <b-col lg="3" class="mb-3 mb-lg-0">
        <b-card no-body class="h-100 master-kas-kecil-menu-card">
          <b-list-group flush>
            <b-list-group-item
              v-for="menu in menus"
              :key="menu.key"
              button
              :active="activeType === menu.key"
              class="master-kas-kecil-menu-item"
              @click="selectMenu(menu.key)"
            >
              {{ menu.label }}
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>

      <b-col lg="9">
        <b-card class="master-kas-kecil-content-card">
          <template v-slot:header>
            <h5 class="mb-0">{{ pageTitle }}</h5>
          </template>

          <div class="d-flex flex-column flex-md-row justify-content-between mb-3">
            <b-input-group class="master-kas-kecil-search mb-3 mb-md-0">
              <b-input-group-prepend is-text>
                <i class="fa fa-search"></i>
              </b-input-group-prepend>
              <b-form-input
                v-model="keyword"
                type="search"
                :placeholder="searchPlaceholder"
              />
            </b-input-group>

            <b-button
              v-if="activeType === 'category'"
              class="ml-md-3"
              variant="pgiBtn"
              @click="openCreateCategoryModal"
            >
              <i class="fa fa-plus mr-1"></i>
              Tambah Kategori
            </b-button>
            <b-button
              v-else-if="activeType === 'itemType'"
              class="ml-md-3"
              variant="pgiBtn"
              :disabled="isOpeningItemTypeModal"
              @click="openCreateItemTypeModal"
            >
              <b-spinner v-if="isOpeningItemTypeModal" small class="mr-1" />
              <i v-else class="fa fa-plus mr-1"></i>
              Tambah Barang/Jasa
            </b-button>
            <b-button
              v-else
              class="ml-md-3"
              variant="pgiBtn"
              @click="openCreateCoaModal"
            >
              <i class="fa fa-plus mr-1"></i>
              Tambah COA
            </b-button>
          </div>

          <b-table
            bordered
            hover
            show-empty
            sticky-header="420px"
            :items="filteredItems"
            :fields="tableFields"
            :busy="isBusy"
            class="mb-0"
          >
            <template v-slot:table-busy>
              <div class="text-center my-3">
                <b-spinner small />
                <span class="ml-2">Memuat data...</span>
              </div>
            </template>
            <template v-slot:empty>
              {{ emptyMessage }}
            </template>
            <template v-slot:cell(name)="row">
              <div>{{ row.item.name }}</div>
              <template v-if="activeType !== 'coa'">
                <div class="smallText text-muted">{{ formatCreatedBy(row.item.createdBy) }}</div>
                <div class="smallText text-muted">{{ formatDateTime(row.item.createdAt) }}</div>
              </template>
            </template>
            <template v-slot:cell(isActive)="row">
              <span :class="row.item.isActive ? 'status-box-md status-box-success' : 'status-box-md status-box-secondary'">
                {{ row.item.isActive ? "Aktif" : "Nonaktif" }}
              </span>
            </template>
            <template v-slot:cell(action)="row">
              <b-button
                size="sm"
                variant="pgiBtn"
                @click="openManagePriceModal(row.item)"
              >
                Edit Harga
              </b-button>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      id="modal-master-kas-kecil"
      title="Tambah Kategori"
      ok-title="Simpan"
      cancel-title="Batal"
      @ok="saveForm"
    >
      <b-form-group label="Nama Kategori">
        <b-form-input
          v-model.trim="form.name"
          :state="formSubmitted ? Boolean(form.name) : null"
          placeholder="Masukkan nama kategori"
          maxlength="255"
          required
        />
        <b-form-invalid-feedback>
          Nama Kategori wajib diisi.
        </b-form-invalid-feedback>
      </b-form-group>
    </b-modal>

    <b-modal
      id="modal-master-kas-kecil-item-type"
      title="Tambah Barang/Jasa"
      ok-title="Simpan"
      cancel-title="Batal"
      :ok-disabled="isLoadingCategoryOptions || isLoadingCoaOptions"
      @ok="saveItemTypeForm"
    >
      <b-form-group label="Kategori">
        <multiselect
          v-model="itemTypeForm.category"
          :options="categoryOptions"
          :disabled="isLoadingCategoryOptions"
          label="name"
          track-by="id"
          placeholder="Pilih kategori"
          select-label=""
          selected-label=""
          deselect-label=""
        />
        <div v-if="itemTypeFormSubmitted && !itemTypeForm.category" class="invalid-feedback d-block">
          Kategori wajib diisi.
        </div>
      </b-form-group>
      <b-form-group label="COA">
        <multiselect
          v-model="itemTypeForm.coa"
          :options="coaOptions"
          :disabled="isLoadingCoaOptions"
          label="label"
          track-by="id"
          placeholder="Pilih COA"
          select-label=""
          selected-label=""
          deselect-label=""
        />
        <div v-if="itemTypeFormSubmitted && !itemTypeForm.coa" class="invalid-feedback d-block">
          COA wajib diisi.
        </div>
      </b-form-group>
      <b-form-group label="Nama Barang/Jasa">
        <b-form-input
          v-model.trim="itemTypeForm.name"
          :state="itemTypeFormSubmitted ? Boolean(itemTypeForm.name) : null"
          placeholder="Masukkan nama barang/jasa"
          maxlength="255"
          required
        />
        <b-form-invalid-feedback>
          Nama Barang/Jasa wajib diisi.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Unit">
        <b-form-input
          v-model.trim="itemTypeForm.unit"
          :state="itemTypeFormSubmitted ? Boolean(itemTypeForm.unit) : null"
          placeholder="Masukkan unit"
          maxlength="255"
          required
        />
        <b-form-invalid-feedback>
          Unit wajib diisi.
        </b-form-invalid-feedback>
      </b-form-group>
    </b-modal>

    <b-modal
      id="modal-manage-price"
      :title="managePriceTitle"
      hide-footer
      size="md"
      body-class="manage-price-body"
    >
      <div class="d-flex justify-content-end mb-3">
        <b-button
          size="sm"
          variant="pgiBtn"
          :disabled="availableProvinceOptions.length === 0"
          @click="openAddPriceModal"
        >
          <i class="fa fa-plus mr-1"></i>
          Tambah Provinsi
        </b-button>
      </div>
      <b-table
        bordered
        hover
        show-empty
        :items="managePriceRows"
        :fields="managePriceFields"
        class="mb-0"
      >
        <template v-slot:empty>
          Belum ada harga untuk provinsi manapun. Klik "Tambah Provinsi" untuk menambahkan.
        </template>
        <template v-slot:cell(maxPricePerQty)="row">
          {{ formatCurrency(row.item.maxPricePerQty) }}
        </template>
        <template v-slot:cell(action)="row">
          <div class="d-flex">
            <b-button
              size="sm"
              class="table-button view mr-2"
              v-b-tooltip.hover
              title="History"
              @click="openHistoryItemTypeModal(row.item)"
            >
              <i class="fa fa-history"></i>
            </b-button>
            <b-button
              size="sm"
              class="table-button view"
              v-b-tooltip.hover
              title="Edit"
              @click="openEditPriceModal(row.item)"
            >
              <i class="fa fa-pencil-square-o"></i>
            </b-button>
          </div>
        </template>
      </b-table>
    </b-modal>

    <b-modal
      id="modal-edit-price"
      :title="editPriceTitle"
      ok-title="Simpan"
      cancel-title="Batal"
      @ok="saveEditPriceForm"
    >
      <b-form-group label="Barang/Jasa">
        <b-form-input :value="editPriceForm.itemTypeName" disabled />
      </b-form-group>
      <b-form-group label="Provinsi">
        <b-form-input :value="editPriceForm.provinceName" disabled />
      </b-form-group>
      <b-form-group label="Harga Maksimal Per Qty">
        <b-input-group prepend="Rp.">
          <b-form-input
            v-model="editPriceForm.maxPricePerQty"
            :state="editPriceFormSubmitted ? isValidEditPrice : null"
            placeholder="Masukkan harga maksimal"
            required
          />
        </b-input-group>
        <div v-if="editPriceFormSubmitted && !isValidEditPrice" class="invalid-feedback d-block">
          Harga Maksimal Per Qty wajib lebih dari 0.
        </div>
      </b-form-group>
    </b-modal>

    <b-modal
      id="modal-add-price"
      :title="addPriceTitle"
      ok-title="Simpan"
      cancel-title="Batal"
      @ok="saveAddPriceForm"
    >
      <b-form-group label="Barang/Jasa">
        <b-form-input :value="addPriceForm.itemTypeName" disabled />
      </b-form-group>
      <b-form-group label="Provinsi">
        <multiselect
          v-model="addPriceForm.province"
          :options="availableProvinceOptions"
          :loading="isLoadingProvinces"
          :internal-search="true"
          label="name"
          track-by="id"
          placeholder="Pilih provinsi"
          select-label=""
          selected-label=""
          deselect-label=""
        />
        <div v-if="addPriceFormSubmitted && !addPriceForm.province" class="invalid-feedback d-block">
          Provinsi wajib diisi.
        </div>
      </b-form-group>
      <b-form-group label="Harga Maksimal Per Qty">
        <b-input-group prepend="Rp.">
          <b-form-input
            v-model="addPriceForm.maxPricePerQty"
            :state="addPriceFormSubmitted ? isValidAddPrice : null"
            placeholder="Masukkan harga maksimal"
            required
          />
        </b-input-group>
        <div v-if="addPriceFormSubmitted && !isValidAddPrice" class="invalid-feedback d-block">
          Harga Maksimal Per Qty wajib lebih dari 0.
        </div>
      </b-form-group>
    </b-modal>

    <b-modal
      id="modal-history-item-type"
      :title="historyItemTypeTitle"
      hide-footer
      size="md"
      body-class="history-item-type-body"
    >
      <div v-if="isLoadingHistoryItemType" class="text-center py-4">
        <b-spinner small class="mr-2" />
        <span class="text-muted">Memuat history...</span>
      </div>
      <p v-else-if="historyItemTypeItems.length === 0" class="mb-0 text-muted text-center py-3">
        Belum ada history perubahan harga.
      </p>
      <ul v-else class="history-item-type-list">
        <li
          v-for="item in historyItemTypeItems"
          :key="item.id"
          class="history-item-type-entry"
        >
          <div
            class="history-item-type-icon"
            :class="isPriceIncrease(item) ? 'history-item-type-icon-up' : 'history-item-type-icon-down'"
          >
            <i class="fa" :class="isPriceIncrease(item) ? 'fa-arrow-up' : 'fa-arrow-down'"></i>
          </div>
          <div class="history-item-type-content">
            <div class="history-item-type-price">
              <span class="text-muted">{{ formatCurrency(item.priceBefore) }}</span>
              <i class="fa fa-long-arrow-right mx-2 text-muted"></i>
              <strong>{{ formatCurrency(item.priceAfter) }}</strong>
              <span
                class="history-item-type-delta"
                :class="isPriceIncrease(item) ? 'history-item-type-delta-up' : 'history-item-type-delta-down'"
              >
                {{ isPriceIncrease(item) ? "+" : "-" }}{{ formatCurrency(getPriceDelta(item)) }}
              </span>
            </div>
            <div class="history-item-type-meta">
              <span>{{ formatCreatedBy(item.createdBy) }}</span>
              <span class="history-item-type-dot">&middot;</span>
              <span>{{ formatDateTime(item.createdAt) }}</span>
            </div>
          </div>
        </li>
      </ul>
    </b-modal>

    <b-modal
      id="modal-master-kas-kecil-coa"
      title="Tambah COA"
      ok-title="Simpan"
      cancel-title="Batal"
      @ok="saveCoaForm"
    >
      <b-form-group label="Kode COA">
        <b-form-input
          v-model.trim="coaForm.code"
          :state="coaFormSubmitted ? Boolean(coaForm.code) : null"
          placeholder="Masukkan kode COA"
          maxlength="255"
          required
        />
        <b-form-invalid-feedback>
          Kode COA wajib diisi.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Nama COA">
        <b-form-input
          v-model.trim="coaForm.name"
          :state="coaFormSubmitted ? Boolean(coaForm.name) : null"
          placeholder="Masukkan nama COA"
          maxlength="255"
          required
        />
        <b-form-invalid-feedback>
          Nama COA wajib diisi.
        </b-form-invalid-feedback>
      </b-form-group>
    </b-modal>

    <ModalConfirm
      id="modal-confirm-create-master-kas-kecil"
      title="Konfirmasi Tambah Kategori"
      desc="Apakah anda yakin menambah Kategori ini?"
      :isSubmitting="isSubmitting"
      @submit="submitCreateCategory"
    />
    <ModalConfirm
      id="modal-confirm-create-master-kas-kecil-item-type"
      title="Konfirmasi Tambah Barang/Jasa"
      desc="Apakah anda yakin menambah Barang/Jasa ini?"
      :isSubmitting="isSubmitting"
      @submit="submitCreateItemType"
    />
    <ModalConfirm
      id="modal-confirm-edit-price"
      title="Konfirmasi Edit Harga Maksimal"
      desc="Apakah anda yakin mengubah Harga Maksimal Per Qty ini?"
      :isSubmitting="isSubmitting"
      @submit="submitEditPrice"
    />
    <ModalConfirm
      id="modal-confirm-add-price"
      title="Konfirmasi Tambah Provinsi"
      desc="Apakah anda yakin menambah harga untuk provinsi ini?"
      :isSubmitting="isSubmitting"
      @submit="submitAddPrice"
    />
    <ModalConfirm
      id="modal-confirm-create-master-kas-kecil-coa"
      title="Konfirmasi Tambah COA"
      desc="Apakah anda yakin menambah COA ini?"
      :isSubmitting="isSubmitting"
      @submit="submitCreateCoa"
    />
  </div>
</template>

<script>
export default {
  name: "MasterKasKecil",
  data() {
    return {
      activeType: "category",
      keyword: "",
      isBusy: false,
      isSubmitting: false,
      formSubmitted: false,
      itemTypeFormSubmitted: false,
      editPriceFormSubmitted: false,
      addPriceFormSubmitted: false,
      coaFormSubmitted: false,
      isLoadingCategoryOptions: false,
      isLoadingCoaOptions: false,
      isOpeningItemTypeModal: false,
      isLoadingHistoryItemType: false,
      selectedHistoryItemType: null,
      historyItemTypeItems: [],
      managePriceItem: null,
      form: {
        name: "",
      },
      coaForm: {
        code: "",
        name: "",
      },
      itemTypeForm: {
        category: null,
        coa: null,
        name: "",
        unit: "",
      },
      editPriceForm: {
        itemTypeId: null,
        itemTypeName: "",
        provinceId: null,
        provinceName: "",
        maxPricePerQty: "",
      },
      addPriceForm: {
        itemTypeId: null,
        itemTypeName: "",
        province: null,
        maxPricePerQty: "",
      },
      menus: [
        { key: "category", label: "Kategori" },
        { key: "itemType", label: "Barang/Jasa" },
        // { key: "coa", label: "COA" },
      ],
      categories: [],
      categoryOptions: [],
      coaOptions: [],
      itemTypes: [],
      coas: [],
      provinceOptions: [],
      isLoadingProvinces: false,
    };
  },
  created() {
    this.loadActiveItems();
  },
  computed: {
    activeMenu() {
      return this.menus.find((menu) => menu.key === this.activeType);
    },
    pageTitle() {
      return `Daftar ${this.activeMenu.label}`;
    },
    searchPlaceholder() {
      return `Cari ${this.activeMenu.label.toLowerCase()}...`;
    },
    items() {
      if (this.activeType === "category") return this.categories;
      if (this.activeType === "coa") return this.coas;
      return this.itemTypes;
    },
    emptyMessage() {
      return `Tidak ada data ${this.activeMenu.label}.`;
    },
    tableFields() {
      if (this.activeType === "category") {
        return [
          { key: "name", label: "Nama Kategori" },
          { key: "isActive", label: "Status", thStyle: { width: "130px" } },
        ];
      }

      if (this.activeType === "coa") {
        return [
          { key: "code", label: "Kode COA" },
          { key: "name", label: "Nama COA" },
        ];
      }

      return [
        { key: "categoryName", label: "Kategori" },
        { key: "name", label: "Nama Barang/Jasa" },
        { key: "unit", label: "Unit", thStyle: { width: "160px" } },
        { key: "action", label: "Aksi", thStyle: { width: "160px" } },
      ];
    },
    managePriceFields() {
      return [
        { key: "provinceName", label: "Provinsi" },
        { key: "maxPricePerQty", label: "Harga Maksimal", thStyle: { width: "160px" } },
        { key: "action", label: "Aksi", thStyle: { width: "90px" } },
      ];
    },
    managePriceRows() {
      if (!this.managePriceItem) return [];
      const prices = Array.isArray(this.managePriceItem.prices) ? this.managePriceItem.prices : [];
      return prices.map((priceEntry) => {
        const province = this.provinceOptions.find((option) => option.id === priceEntry.provinceId);
        return {
          itemTypeId: this.managePriceItem.id,
          provinceId: priceEntry.provinceId,
          provinceName: province ? province.name : priceEntry.provinceName,
          maxPricePerQty: priceEntry.maxPricePerQty || 0,
        };
      }).sort((a, b) => a.provinceName.localeCompare(b.provinceName));
    },
    availableProvinceOptions() {
      if (!this.managePriceItem) return this.provinceOptions;
      const prices = Array.isArray(this.managePriceItem.prices) ? this.managePriceItem.prices : [];
      const usedProvinceIds = prices.map((priceEntry) => priceEntry.provinceId);
      return this.provinceOptions.filter((province) => !usedProvinceIds.includes(province.id));
    },
    managePriceTitle() {
      if (!this.managePriceItem) return "Edit Harga";
      return `Edit Harga - ${this.managePriceItem.name}`;
    },
    isValidAddPrice() {
      return this.getAddPriceValue() > 0;
    },
    filteredItems() {
      const keyword = this.keyword.toLowerCase();
      return this.items.filter((item) => {
        const name = String(item.name || "").toLowerCase();
        const code = String(item.code || "").toLowerCase();
        const categoryName = String(item.categoryName || "").toLowerCase();
        return name.includes(keyword) || code.includes(keyword) || categoryName.includes(keyword);
      });
    },
    isValidEditPrice() {
      return this.getEditPriceValue() > 0;
    },
    editPriceTitle() {
      if (!this.editPriceForm.itemTypeName) return "Edit Harga Maksimal";
      return `Edit Harga Maksimal - ${this.editPriceForm.itemTypeName} (${this.editPriceForm.provinceName})`;
    },
    addPriceTitle() {
      if (!this.addPriceForm.itemTypeName) return "Tambah Provinsi";
      return `Tambah Provinsi - ${this.addPriceForm.itemTypeName}`;
    },
    historyItemTypeTitle() {
      if (!this.selectedHistoryItemType) return "History Harga";
      return `History Harga - ${this.selectedHistoryItemType.name} (${this.selectedHistoryItemType.provinceName})`;
    },
  },
  methods: {
    selectMenu(type) {
      this.activeType = type;
      this.keyword = "";
      this.loadActiveItems();
    },
    loadActiveItems() {
      if (this.activeType === "category") {
        this.loadCategories();
        return;
      }

      if (this.activeType === "coa") {
        this.loadCoas();
        return;
      }

      if (this.provinceOptions.length === 0 && !this.isLoadingProvinces) {
        this.loadProvinces();
      }

      this.loadItemTypes();
    },
    loadProvinces() {
      this.isLoadingProvinces = true;
      return this.$axios
        .get("mini-cash/province")
        .then((response) => {
          this.provinceOptions = Array.isArray(response.data) ? response.data : [];
        })
        .catch((error) => {
          this.provinceOptions = [];
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isLoadingProvinces = false;
        });
    },
    loadCategories() {
      this.isBusy = true;
      return this.$axios
        .get("mini-cash/item/get-category")
        .then((response) => {
          this.categories = Array.isArray(response.data) ? response.data : [];
        })
        .catch((error) => {
          this.categories = [];
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    loadItemTypes() {
      this.isBusy = true;
      return this.$axios
        .get("mini-cash/item-type/")
        .then((response) => {
          this.itemTypes = Array.isArray(response.data) ? response.data : [];
        })
        .catch((error) => {
          this.itemTypes = [];
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    loadCoas() {
      this.isBusy = true;
      return this.$axios
        .get("mini-cash/item/get-coa")
        .then((response) => {
          this.coas = Array.isArray(response.data) ? response.data : [];
        })
        .catch((error) => {
          this.coas = [];
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    openCreateCategoryModal() {
      this.formSubmitted = false;
      this.form = {
        name: "",
      };
      this.$bvModal.show("modal-master-kas-kecil");
    },
    openCreateItemTypeModal() {
      this.itemTypeFormSubmitted = false;
      this.itemTypeForm = {
        category: null,
        coa: null,
        name: "",
        unit: "",
      };
      this.isOpeningItemTypeModal = true;
      Promise.all([
        this.loadCategoryOptions(),
        this.loadCoaOptions(),
      ]).then(() => {
        this.$bvModal.show("modal-master-kas-kecil-item-type");
      }).finally(() => {
        this.isOpeningItemTypeModal = false;
      });
    },
    openManagePriceModal(item) {
      this.managePriceItem = item;
      if (this.provinceOptions.length === 0 && !this.isLoadingProvinces) {
        this.loadProvinces();
      }
      this.$bvModal.show("modal-manage-price");
    },
    openHistoryItemTypeModal(row) {
      this.selectedHistoryItemType = {
        itemTypeId: row.itemTypeId,
        provinceId: row.provinceId,
        provinceName: row.provinceName,
        name: this.managePriceItem ? this.managePriceItem.name : "",
      };
      this.historyItemTypeItems = [];
      this.$bvModal.show("modal-history-item-type");
      this.loadHistoryItemType(this.selectedHistoryItemType);
    },
    loadHistoryItemType(item) {
      this.isLoadingHistoryItemType = true;
      return this.$axios
        .get("mini-cash/item/type-history/", {
          params: {
            miniCashItemTypeId: item.itemTypeId,
            provinsiId: item.provinceId,
          },
        })
        .then((response) => {
          this.historyItemTypeItems = Array.isArray(response.data) ? response.data : [];
        })
        .catch((error) => {
          this.historyItemTypeItems = [];
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isLoadingHistoryItemType = false;
        });
    },
    isPriceIncrease(item) {
      return Number(item.priceAfter || 0) >= Number(item.priceBefore || 0);
    },
    getPriceDelta(item) {
      return Math.abs(Number(item.priceAfter || 0) - Number(item.priceBefore || 0));
    },
    openEditPriceModal(row) {
      this.editPriceFormSubmitted = false;
      this.editPriceForm = {
        itemTypeId: row.itemTypeId,
        itemTypeName: this.managePriceItem ? this.managePriceItem.name : "",
        provinceId: row.provinceId,
        provinceName: row.provinceName,
        maxPricePerQty: this.formatCurrencyInput(String(row.maxPricePerQty || "")),
      };
      this.$bvModal.show("modal-edit-price");
    },
    openAddPriceModal() {
      this.addPriceFormSubmitted = false;
      this.addPriceForm = {
        itemTypeId: this.managePriceItem ? this.managePriceItem.id : null,
        itemTypeName: this.managePriceItem ? this.managePriceItem.name : "",
        province: null,
        maxPricePerQty: "",
      };
      this.$bvModal.show("modal-add-price");
    },
    openCreateCoaModal() {
      this.coaFormSubmitted = false;
      this.coaForm = {
        code: "",
        name: "",
      };
      this.$bvModal.show("modal-master-kas-kecil-coa");
    },
    loadCategoryOptions() {
      this.isLoadingCategoryOptions = true;
      return this.$axios
        .get("mini-cash/item/get-category")
        .then((response) => {
          const data = Array.isArray(response.data) ? response.data : [];
          this.categoryOptions = data.filter((item) => item.isActive === true);
        })
        .catch((error) => {
          this.categoryOptions = [];
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isLoadingCategoryOptions = false;
        });
    },
    loadCoaOptions() {
      this.isLoadingCoaOptions = true;
      return this.$axios
        .get("mini-cash/item/get-coa")
        .then((response) => {
          const data = Array.isArray(response.data) ? response.data : [];
          this.coaOptions = data.map((item) => ({
            ...item,
            label: this.getCoaLabel(item),
          }));
        })
        .catch((error) => {
          this.coaOptions = [];
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isLoadingCoaOptions = false;
        });
    },
    saveForm(event) {
      this.formSubmitted = true;
      if (!this.form.name) {
        event.preventDefault();
        this.$helper.toastErr(this, "Nama Kategori wajib diisi.");
        return;
      }

      event.preventDefault();
      this.$bvModal.show("modal-confirm-create-master-kas-kecil");
    },
    saveItemTypeForm(event) {
      this.itemTypeFormSubmitted = true;
      if (!this.isItemTypeFormValid()) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      this.$bvModal.show("modal-confirm-create-master-kas-kecil-item-type");
    },
    saveEditPriceForm(event) {
      this.editPriceFormSubmitted = true;
      if (!this.isValidEditPrice) {
        event.preventDefault();
        this.$helper.toastErr(this, "Harga Maksimal Per Qty wajib lebih dari 0.");
        return;
      }

      event.preventDefault();
      this.$bvModal.show("modal-confirm-edit-price");
    },
    saveAddPriceForm(event) {
      this.addPriceFormSubmitted = true;
      if (!this.addPriceForm.province) {
        event.preventDefault();
        this.$helper.toastErr(this, "Provinsi wajib diisi.");
        return;
      }

      if (!this.isValidAddPrice) {
        event.preventDefault();
        this.$helper.toastErr(this, "Harga Maksimal Per Qty wajib lebih dari 0.");
        return;
      }

      event.preventDefault();
      this.$bvModal.show("modal-confirm-add-price");
    },
    saveCoaForm(event) {
      this.coaFormSubmitted = true;
      if (!this.isCoaFormValid()) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      this.$bvModal.show("modal-confirm-create-master-kas-kecil-coa");
    },
    isItemTypeFormValid() {
      if (!this.itemTypeForm.category) {
        this.$helper.toastErr(this, "Kategori wajib diisi.");
        return false;
      }

      if (!this.itemTypeForm.coa) {
        this.$helper.toastErr(this, "COA wajib diisi.");
        return false;
      }

      if (!this.itemTypeForm.name) {
        this.$helper.toastErr(this, "Nama Barang/Jasa wajib diisi.");
        return false;
      }

      if (!this.itemTypeForm.unit) {
        this.$helper.toastErr(this, "Unit wajib diisi.");
        return false;
      }

      return true;
    },
    isCoaFormValid() {
      if (!this.coaForm.code) {
        this.$helper.toastErr(this, "Kode COA wajib diisi.");
        return false;
      }

      if (!this.coaForm.name) {
        this.$helper.toastErr(this, "Nama COA wajib diisi.");
        return false;
      }

      return true;
    },
    getCoaLabel(item) {
      return `(${item.code || "-"}) ${item.name || "-"}`;
    },
    submitCreateCategory() {
      this.isSubmitting = true;
      this.$axios
        .post("mini-cash/item/input-category", null, {
          params: {
            name: this.form.name,
          },
        })
        .then(() => {
          this.$helper.toastSucc(this, "Kategori berhasil ditambahkan.");
          this.$bvModal.hide("modal-confirm-create-master-kas-kecil");
          this.$bvModal.hide("modal-master-kas-kecil");
          this.form.name = "";
          this.formSubmitted = false;
          this.loadCategories();
        })
        .catch((error) => this.$helper.parseError(this, error))
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    submitCreateItemType() {
      if (!this.isItemTypeFormValid()) return;

      this.isSubmitting = true;
      this.$axios
        .post("mini-cash/item/input-item-type/", null, {
          params: {
            categoryId: this.itemTypeForm.category.id,
            coaId: this.itemTypeForm.coa.id,
            name: this.itemTypeForm.name,
            unit: this.itemTypeForm.unit,
          },
        })
        .then(() => {
          this.$helper.toastSucc(this, "Barang/Jasa berhasil ditambahkan.");
          this.$bvModal.hide("modal-confirm-create-master-kas-kecil-item-type");
          this.$bvModal.hide("modal-master-kas-kecil-item-type");
          this.itemTypeFormSubmitted = false;
          this.loadItemTypes();
        })
        .catch((error) => this.$helper.parseError(this, error))
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    submitCreateCoa() {
      if (!this.isCoaFormValid()) return;

      this.isSubmitting = true;
      this.$axios
        .post("mini-cash/item/input-coa", null, {
          params: {
            code: this.coaForm.code,
            name: this.coaForm.name,
          },
        })
        .then(() => {
          this.$helper.toastSucc(this, "COA berhasil ditambahkan.");
          this.$bvModal.hide("modal-confirm-create-master-kas-kecil-coa");
          this.$bvModal.hide("modal-master-kas-kecil-coa");
          this.coaFormSubmitted = false;
          this.loadCoas();
        })
        .catch((error) => this.$helper.parseError(this, error))
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    getEditPriceValue() {
      return Number(this.$helper.removeThousandSeparator(this.editPriceForm.maxPricePerQty || 0));
    },
    submitEditPrice() {
      if (!this.editPriceForm.itemTypeId || !this.editPriceForm.provinceId) {
        this.$helper.toastErr(this, "Provinsi atau Barang/Jasa tidak ditemukan.");
        return;
      }

      this.isSubmitting = true;
      this.$axios
        .put(`mini-cash/edit-type/${this.editPriceForm.itemTypeId}`, null, {
          params: {
            provinceId: this.editPriceForm.provinceId,
            maxPricePerQty: this.getEditPriceValue(),
          },
        })
        .then(() => {
          this.$helper.toastSucc(this, "Harga Maksimal Per Qty berhasil diubah.");
          this.$bvModal.hide("modal-confirm-edit-price");
          this.$bvModal.hide("modal-edit-price");
          this.editPriceFormSubmitted = false;
          this.updateLocalPrice(this.editPriceForm.itemTypeId, this.editPriceForm.provinceId, this.getEditPriceValue());
        })
        .catch((error) => this.$helper.parseError(this, error))
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    updateLocalPrice(itemTypeId, provinceId, maxPricePerQty) {
      const item = this.itemTypes.find((itemType) => itemType.id === itemTypeId);
      if (!item) return;
      if (!Array.isArray(item.prices)) item.prices = [];

      const priceEntry = item.prices.find((price) => price.provinceId === provinceId);
      if (priceEntry) {
        priceEntry.maxPricePerQty = maxPricePerQty;
      } else {
        const province = this.provinceOptions.find((option) => option.id === provinceId);
        item.prices.push({
          provinceId,
          provinceName: province ? province.name : "",
          maxPricePerQty,
        });
      }
    },
    getAddPriceValue() {
      return Number(this.$helper.removeThousandSeparator(this.addPriceForm.maxPricePerQty || 0));
    },
    submitAddPrice() {
      if (!this.addPriceForm.itemTypeId || !this.addPriceForm.province) {
        this.$helper.toastErr(this, "Provinsi atau Barang/Jasa tidak ditemukan.");
        return;
      }

      this.isSubmitting = true;
      this.$axios
        .post("mini-cash/item-type/input-price/", null, {
          params: {
            itemTypeId: this.addPriceForm.itemTypeId,
            provinceId: this.addPriceForm.province.id,
            maxPricePerQty: this.getAddPriceValue(),
          },
        })
        .then(() => {
          this.$helper.toastSucc(this, "Provinsi berhasil ditambahkan.");
          this.$bvModal.hide("modal-confirm-add-price");
          this.$bvModal.hide("modal-add-price");
          this.addPriceFormSubmitted = false;
          this.updateLocalPrice(this.addPriceForm.itemTypeId, this.addPriceForm.province.id, this.getAddPriceValue());
        })
        .catch((error) => this.$helper.parseError(this, error))
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    formatCurrency(value) {
      return `Rp. ${this.$helper.addThousandSeparator(Number(value || 0))}`;
    },
    formatDateTime(value) {
      if (this.$helper.isNullOrEmpty(value) || value === "-") return "";
      return `${this.$helper.changeDateFormat(value)} ${this.$helper.changeDateFormatGetHour(value)}`;
    },
    formatCreatedBy(value) {
      if (this.$helper.isNullOrEmpty(value) || value === "-") return "";
      return value;
    },
    formatCreatedBy(value) {
      if (this.$helper.isNullOrEmpty(value) || value === "-") return "";
      return value;
    },
    formatCurrencyInput(value) {
      if (this.$helper.isNullOrEmpty(value)) return "";
      const cleanValue = this.$helper.changeToValue(String(value));
      return cleanValue.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  watch: {
    "editPriceForm.maxPricePerQty": function (newValue) {
      const result = this.formatCurrencyInput(newValue);
      if (newValue === result) return;
      this.$nextTick(() => this.editPriceForm.maxPricePerQty = result);
    },
    "addPriceForm.maxPricePerQty": function (newValue) {
      const result = this.formatCurrencyInput(newValue);
      if (newValue === result) return;
      this.$nextTick(() => this.addPriceForm.maxPricePerQty = result);
    },
  },
};
</script>

<style scoped>
.master-kas-kecil-menu-card,
.master-kas-kecil-content-card {
  height: 100%;
  min-height: 520px;
}

.master-kas-kecil-row > [class*="col-"] {
  display: flex;
  flex-direction: column;
}

.master-kas-kecil-row .card {
  flex: 1;
}

.master-kas-kecil-menu-card .list-group {
  padding: 8px;
}

.master-kas-kecil-menu-item {
  color: var(--pgi-fg);
}

.master-kas-kecil-menu-card .list-group .master-kas-kecil-menu-item.list-group-item {
  margin: 1px 0;
  padding: 12px 16px;
  font-weight: 600;
  border: 0;
  border-radius: var(--pgi-radius);
  transition: background-color 0.15s ease, color 0.15s ease;
}

.master-kas-kecil-menu-item:hover {
  color: var(--pgi-primary);
  background-color: var(--pgi-soft-bg);
}

.master-kas-kecil-menu-item.active,
.master-kas-kecil-menu-item.active:hover {
  color: #fff;
  background-color: var(--pgi-primary);
}

.master-kas-kecil-search {
  width: 340px;
}

@media (max-width: 767.98px) {
  .master-kas-kecil-menu-card,
  .master-kas-kecil-content-card {
    min-height: auto;
  }

  .master-kas-kecil-search {
    width: 100%;
  }
}

.history-item-type-body {
  max-height: 420px;
  overflow-y: auto;
}

.history-item-type-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.history-item-type-entry {
  align-items: flex-start;
  border-bottom: 1px solid var(--pgi-border);
  display: flex;
  gap: 12px;
  padding: 12px 4px;
}

.history-item-type-entry:last-child {
  border-bottom: none;
  padding-bottom: 4px;
}

.history-item-type-entry:first-child {
  padding-top: 4px;
}

.history-item-type-icon {
  align-items: center;
  border-radius: 50%;
  display: flex;
  flex-shrink: 0;
  height: 32px;
  justify-content: center;
  width: 32px;
}

.history-item-type-icon-up {
  background-color: #E9F9EE;
  color: #15803D;
}

.history-item-type-icon-down {
  background-color: #FEF0F0;
  color: #B91C1C;
}

.history-item-type-content {
  flex: 1;
  min-width: 0;
}

.history-item-type-price {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
}

.history-item-type-delta {
  border-radius: 50em;
  font-size: 12px;
  font-weight: 700;
  margin-left: 8px;
  padding: 1px 8px;
}

.history-item-type-delta-up {
  background-color: #E9F9EE;
  color: #15803D;
  box-shadow: inset 0 0 0 1px rgba(21, 128, 61, 0.2);
}

.history-item-type-delta-down {
  background-color: #FEF0F0;
  color: #B91C1C;
  box-shadow: inset 0 0 0 1px rgba(185, 28, 28, 0.2);
}

.history-item-type-meta {
  color: var(--pgi-muted);
  font-size: 12px;
  margin-top: 4px;
}

.history-item-type-dot {
  margin: 0 6px;
}
</style>
